import { Box, Container, FormField, Header, Select, SpaceBetween, Table } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import { useEffect, useMemo, useState } from 'react';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
const _preserve = React.version;
////import { useStoreAdmin } from '../../../context/useStoreAdmin';
//import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { buildBreadcrumbItems, formatPhone, getCookie, getUrlVersion, setLoading, setParameters } from '../../../../commons/functions';


import { mdiCircle } from '@mdi/js';
import Icon from '@mdi/react';
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import React from 'react';
import DPModal from '../../../../../components/DPModal';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemBooking, ItemShift } from '../../../../../resources/types';
dayjs.extend(isBetween);


const pageSize = 20;

export const OPSPlanningTowingsPage = () => {

    const { menu, parameters } = useGlobalState();

    const [inSeason, setInSeason] = useState<any[]>([]);
    const [time, setTime] = useState<any>();
    const [outSeason, setOutSeason] = useState<any[]>([]);
    const [bookings, setBookings] = useState<any[]>([]);
    const [bookingsGeneral, setBookingsGeneral] = useState<ItemBooking[]>([]);
    const [shifts, setShifts] = useState<ItemShift[]>([]);
    const [season, setSeason] = useState({ label: "Temporada", value: "inseason" });




    const handleRefresh = async () => {
        if (parameters && parameters.date && parameters.date !== "") {
            try {
                setInSeason([]);
                setOutSeason([]);
                setBookings([]);
                setLoading(true);
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/reports/ops/towingtimes',
                        'JWT': getCookie("JWT"),

                    },
                    body: JSON.stringify({
                        date: parameters.date,
                    })
                });

                if (!response.ok) {
                    //console.log(response)
                    throw new Error(`HTTP error: ${response.status}`);
                }

                const data = await response.json();
                if (data) {
                    setInSeason(data.towings.inseason)
                    setOutSeason(data.towings.outseason)
                    data.bookings !== null ? setBookings(data.bookings) : setBookings([])
                    data.bookingsGeneral !== null ? setBookingsGeneral(data.bookingsGeneral) : setBookings([])
                    setTime(data.time)
                    setShifts(data.shifts)
                }
                //storeAdmin(data);
                // Create a new list with updated 'accesos' field before setting it to state

            } catch (error) {
                console.error('Error fetching users:', error);
            } finally {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        if (parameters.date != "") {
            handleRefresh();
        }
    }, [parameters.date]);
    const hours = Array.from({ length: 11 }, (_, i) => i + 9); // [9, 10, ..., 21]
    interface BookingData {
        hour: number;
        totalBookings: number;
        totalMinutes: number;
        towType: string;
    }

    interface CellData {
        bookings: number;
        minutes: number;
        towType: string;
    }

    interface TableRow {
        towType: string;
        [key: number]: CellData; // Index signature for the hour columns
    }
    const formatTowType = (type: string) => {
        if (type === "NONE") return "Autodespegue";
        if (type === "BALLAST") return "Lastre";
        if (type === "MOUNTAIN") return "Cordillera";
        if (type === "LOCAL") return "Local";
        if (type === "SANRAMON") return "San Ramón";
        if (type === "TOTALS") return "TOTALES";
        return type; // Returns the Pilot's Display Name or original string if no match
    };
    const getFlightRows = (flightBookings: any[]) => {
        return flightBookings.map(fb => {
            const row: any = {
                towType: fb.displayName, // We'll use this column for the Name
                registration: fb.registration,
                isFlightRow: true
            };

            // Extract hours from "14-03-2026 09:00" format
            const startHour = parseInt(fb.dateStart.split(' ')[1].split(':')[0]);
            const endHour = parseInt(fb.dateEnd.split(' ')[1].split(':')[0]);

            hours.forEach(h => {
                // Mark with "*" if the hour falls within the booking range
                row[h] = (h >= startHour && h < endHour) ? <Icon path={mdiCircle} size={0.75} />
                    : <Icon path={mdiCircle} size={0.75} color='#eee' />;
            });
            return row;
        });
    };
    const getTableData = (bookings: BookingData[]) => {
        // 1. Get unique Tow Types - Added casing fallback
        const towTypes = [...new Set(bookings.map(item => item.towType || item.towType))];

        // 2. Build the rows
        const rows: TableRow[] = towTypes.map(type => {
            const row: TableRow = { towType: type };
            hours.forEach(h => {
                // Added casing fallback for towType and hour property names
                const match = bookings.find(d =>
                    (d.towType === type || d.towType === type) &&
                    (d.hour === h || d.hour === h)
                );
                row[h] = match
                    ? {
                        bookings: match.totalBookings || match.totalBookings,
                        minutes: match.totalMinutes || match.totalMinutes,
                        towType: type
                    }
                    : { bookings: 0, minutes: 0, towType: type };
            });
            return row;
        });

        // 3. Calculate Totals Row (Keep your logic exactly as is)
        const totals: TableRow = { towType: 'TOTALS' };
        hours.forEach(h => {
            const hourData = bookings.filter(d => (d.hour === h || d.hour === h) && (d.towType !== 'NONE' && d.towType !== 'NONE'));

            totals[h] = {
                bookings: hourData.reduce((sum, curr) => sum + (curr.totalBookings || curr.totalBookings || 0), 0),
                minutes: hourData.reduce((sum, curr) => sum + (curr.totalMinutes || curr.totalMinutes || 0), 0),
                towType: 'TOTALS'
            };
        });

        return { rows, totals };
    };
    const columnDefinitions = [
        {
            id: "towType",
            header: "Tipo remolque",
            cell: (item: any) => (
                <Box
                    variant={item.isTotal ? "awsui-key-label" : "p"}
                    fontWeight={item.isTotal ? "bold" : "normal"}
                >
                    {item.isFlightRow ? item.towType : formatTowType(item.towType)}
                </Box>
            ),
            width: 200,
            sticky: "left" as const
        },
        ...hours.map(h => ({
            id: `hour-${h}`,
            header: `${h}`,
            cell: (item: any) => {
                // Logic for Flight Rows
                if (item.isFlightRow) {
                    return <Box textAlign="center" fontWeight="heavy">{item[h]}</Box>;
                }

                // Logic for Towing Stats Rows
                const data = item[h];
                if (!data || (data.bookings === 0 && data.minutes === 0)) return "-";
                return (
                    <Box textAlign="center">
                        <Box variant="p" margin={{ bottom: 'n' }}><strong>{data.bookings}</strong></Box>
                        <Box color="text-status-inactive" variant="small">{data.minutes}m</Box>
                    </Box>
                );
            }
        }))
    ];
    const BookingStatsTable = ({ rawData, flightBookings }: { rawData: any; flightBookings: any[] }) => {
        const items = useMemo(() => {
            const inseasonData = rawData?.inseason || [];
            const sourceData = Array.isArray(rawData) ? rawData : inseasonData;
            //console.log("Source Data Sample:", sourceData[0]);
            const { rows: towingRows, totals } = getTableData(sourceData);

            const flightRows = getFlightRows(flightBookings || []);
            return [
                ...towingRows,
                { ...totals, isTotal: true },
                ...flightRows
            ];
        }, [rawData, flightBookings]);

        return (
            <Container header={<Header variant="h2">Consolidación</Header>}>
                <Table
                    columnDefinitions={columnDefinitions}
                    items={items}
                    trackBy={(item) => item.idBooking || item.towType || item.displayName || Math.random().toString()}
                    stickyHeader={true}
                    variant="embedded"
                    empty={
                        <Box textAlign="center" color="inherit">
                            <b>No data available</b>
                        </Box>
                    }
                />
            </Container>
        );
    };
    return (
        <CustomAppLayout
            toolsHide={true}


            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="xs">


                    <Header actions={


                        <Favorites />
                    }>Planificación de remolques
                    </Header>
                    <SpaceBetween size="xs" direction='vertical'>
                        <SpaceBetween size="xs" direction='horizontal'>
                            <FormField label={"Fecha"}>
                                <DPModal today date={parameters.date} clear={false} tomorrow onConfirm={(date) => {
                                    if (date !== "") {
                                        const updatedParameters = {
                                            ...parameters, // clone existing keys
                                            date: (date) // add or update
                                        };
                                        setParameters(updatedParameters);
                                    }
                                }} />
                            </FormField>
                            <FormField label={"Temporada"}>
                                <Select
                                    selectedOption={season}
                                    onChange={(event) => {
                                        setSeason({ value: event.detail.selectedOption.value, label: event.detail.selectedOption.label })
                                    }}
                                    options={[{
                                        label: "Temporada", value: "inseason"
                                    },
                                    {
                                        label: "Fuera temporada", value: "outseason",
                                    }]} />

                            </FormField>
                            {
                                /*
                            <FormField label={"&nbsp;"}>
                                <Button onClick={() => handleRefresh()} disabled={parameters.date === ""} variant='primary'>Generar</Button>
                            </FormField>
                                */
                            }
                        </SpaceBetween>

                        {bookings && bookings.length == 0 && (
                            <Box>Sin reservas en la fecha seleccionada</Box>
                        )}
                        {(bookings && inSeason) && (
                            <>
                                {inSeason && season.value == "inseason" && (
                                    <>
                                        <BookingStatsTable flightBookings={bookings} rawData={inSeason ?? []} />
                                    </>
                                )}
                                {outSeason && season.value == "outseason" && (
                                    <>
                                        <BookingStatsTable flightBookings={bookings} rawData={outSeason ?? []} />
                                    </>
                                )}
                            </>
                        )}
                        {(bookingsGeneral && bookingsGeneral.length > 0) && (
                            <>
                                <Container header={<Header variant="h2">Planeadores en Reservas</Header>}>
                                    <SpaceBetween direction="vertical" size="xs">
                                        <Box>*Solo en consideración para organización de linea de despegue</Box>
                                        <Box>**Reserva de instrucción FDS, puede ser más de 1 remolque</Box>
                                        <Table
                                            variant="embedded"
                                            items={bookingsGeneral ?? []}
                                            columnDefinitions={[
                                                {
                                                    id: "equiopment",
                                                    header: "Material",
                                                    cell: item => <FormField label={item.registration}>{item.displayName}</FormField>,
                                                },
                                                {
                                                    id: "dateStart",
                                                    header: "Salida",
                                                    cell: item => item.timeStart,
                                                },
                                                {
                                                    id: "towTime",
                                                    header: "Tº Remolque",
                                                    cell: item => `${item?.towingMinutes ?? ""} ${item.idEquipment === 1862806 ? "**" : ""} ${item.towType === "NONE" ? "*" : ""} `,
                                                },
                                                {
                                                    id: "dateEnd",
                                                    header: "Llegada",
                                                    cell: item => item.timeEnd,
                                                },
                                                {
                                                    id: "bookingType",
                                                    header: "Tipo",
                                                    cell: item => (item.bookingType),
                                                },
                                                {
                                                    id: "towType",
                                                    header: "Remolque",
                                                    cell: item => formatTowType(item.towType),
                                                },
                                            ]}
                                            stickyHeader
                                        />
                                    </SpaceBetween>
                                </Container>
                            </>
                        )}
                        {(shifts && shifts.length > 0) && (
                            <>

                                <Container header={<Header variant="h2">Turnos</Header>}>
                                    <SpaceBetween direction="vertical" size="xs">
                                        <Table
                                            variant="embedded"
                                            items={shifts ?? []}
                                            columnDefinitions={[
                                                {
                                                    id: "user",
                                                    header: "Usuario",
                                                    cell: item => item.user,
                                                },
                                                {
                                                    id: "shift",
                                                    header: "Tipo",
                                                    cell: item => item.shift,
                                                },
                                                {
                                                    id: "phone1",
                                                    header: "Móvil",
                                                    cell: item => formatPhone(item.phone1 ?? ""),
                                                },
                                                {
                                                    id: "email",
                                                    header: "Email",
                                                    cell: item => item.email,
                                                },
                                            ]}
                                            stickyHeader
                                        />
                                    </SpaceBetween>
                                </Container>
                            </>
                        )}
                    </SpaceBetween>

                </SpaceBetween >
            }
        />

    );
};